var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.46a5.295 5.295 0 01-5.29 5.29H4.59a4.235 4.235 0 01-4.024-2.9 1.25 1.25 0 112.372-.79 1.74 1.74 0 001.652 1.19h3.123a2.792 2.792 0 002.789-2.789 2.792 2.792 0 00-2.789-2.788H1.75a1.25 1.25 0 01-1.23-1.47l1.25-6.922A1.25 1.25 0 013 .251h7.5a1.25 1.25 0 010 2.5H4.044l-.798 4.42h4.465c2.918 0 5.289 2.34 5.289 5.29z",
    fill: "#00B9EF"
  })));
}

export default SvgFive;